import { render, staticRenderFns } from "./SideMenuSlide.vue?vue&type=template&id=5710fe80&scoped=true&"
import script from "./SideMenuSlide.vue?vue&type=script&lang=js&"
export * from "./SideMenuSlide.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuSlide.vue?vue&type=style&index=0&id=5710fe80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710fe80",
  null
  
)

export default component.exports